import React, { useState, useEffect, useRef } from "react";
// import { generateEmailHTML } from "../../../helpers/EmailTemplate";
import styled, { ServerStyleSheet } from "styled-components";
import theme from "../../../assets/theme";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import { generateEmaiSendlHTML } from "./EmailSendTemplates";
import HostService from "../../../services/HostService";
import ActionBar from "../../common/ActionBar";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import EventConfirmation from "./EventConfirmation";
import { renderToString } from "react-dom/server";
import SendMail from "./SendMail";

const EmailSender = (id) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState({});
  const contentRef = useRef(null);
  const [value, setValue] = useState([]);
  const location = useLocation();

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching preview..." });
        const response = await EventService.getEventInfoData(id?.id);
        const res = await HostService.activeOrganisation();
        setState({
          metaData: {
            ...response?.metaData,
            orgName: res.organizations.filter(
              (item) => item.orgId === parseInt(response?.metaData?.orgId),
            )[0]?.orgName,
          },
        });
        localStorage.setItem("communicate-tab", location?.state.communicateTab);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function sendEmail(template) {
    const sheet = new ServerStyleSheet();
    try {
      setLoader({ state: true, message: "send email..." });

      const html = renderToString(
        sheet.collectStyles(<SendMail meta={state?.metaData} {...{ value }} />),
      );
      const styleTags = sheet.getStyleTags(); // returns <style> with all styles

      const fullHtml = `
        <html>
          <head>${styleTags}</head>
          <body>${html}</body>
        </html>
      `;

      const payload = {
        subjectLine: `CONFIRMED: ${state?.metaData?.eventTitle} on ${state?.metaData?.eventDate} at ${state?.metaData?.eventTime}`,
        emailTemplate: fullHtml,
        eventId: id?.id,
      };
      const response = await EventService.sendEmail(payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "tickers":
        id?.id
          ? navigate(`/dashboard/eventmanager/tickers/${id?.id}`)
          : navigate(`/dashboard/eventmanager/tickers`);
        break;
      default:
        break;
    }
  };

  const copyToClipboard = () => {
    if (contentRef.current) {
      const inputs = contentRef.current.querySelectorAll(
        'input[type="text"], textarea',
      );

      inputs.forEach((input) => {
        const span = document.createElement("span");
        span.textContent = input.value ? input.value : "-"; // Get the value from input
        input.replaceWith(span); // Replace input with its value
      });

      // Select and copy the modified content
      const range = document.createRange();
      range.selectNode(contentRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
    }
  };

  return (
    <Container>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Tickers",
                "Preview",
                state?.metaData?.eventName
                  ? `${state?.metaData?.eventName} (${state?.metaData?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "Tickers", "Preview"]
        }
        {...{ onBreadcrumbClick }}
      />
      {Object.keys(state).length > 0 && (
        <>
          <EmailContainer>
            <PrimaryCTAButton
              style={{ width: "130px", marginRight: "8px" }}
              onClick={() => copyToClipboard()}
            >
              copy
            </PrimaryCTAButton>
            <PrimaryCTAButton
              style={{ width: "130px", marginRight: "8px" }}
              onClick={() => sendEmail(generateEmaiSendlHTML(state?.metaData))}
            >
              Send Email
            </PrimaryCTAButton>
          </EmailContainer>
          <FormContainer>
            <EventConfirmation
              meta={state?.metaData}
              contentRef={contentRef}
              {...{ value, setValue }}
            />
          </FormContainer>
        </>
      )}
    </Container>
  );
};

export default EmailSender;

const Container = styled.div`
  margin: 0 15px;
  outline: none;
  border-radius: 8px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;

const FormContainer = styled.p`
  padding-top: 14px;
  padding-left: 54px;
  padding-right: 54px;
  padding-bottom: 26px;
  // height: 610px;
  // overflow: auto;
  & form {
    padding-top: 10px;
  }
`;

const EmailContainer = styled.div`
  padding-top: 10px;
  padding-right: 64px;
  display: flex;
  justify-content: end;
  align-items: end;
  position: relative;
`;
